import React from //useState,
//useEffect,
//useMemo,
'react';

// import {
// 	useSelector,
// 	useDispatch
// } from 'react-redux';

import { GenericDictSelect } from './genericDictSelect.js';

export const WoolGrowthSelect = (props) => {
	if (props.species === 'Sheep') {
		const types = {
			0: '0',
			1: '1',
			2: '2',
			3: '3',
			4: '4',
			5: '5',
			6: '6',
			7: '7',
			8: '8',
			9: '9',
			10: '10',
			11: '11',
			12: '12',
		};

		return (
			<>
				<GenericDictSelect
					id="WoolGrowth"
					label="Wool Growth (months)"
					dataDict={types}
					cols={props.cols}
					controlStyle={props.controlStyle}
					handleChange={(evt) => props.handleChange(evt)}
					value={props.value}
					required={props.size}
					//pattern = {'^\d+$'}	// integer
					pattern={'^[a-zA-Z0-9-+]+$'}
					invalidMsg="Select wool growth!"
					selectDotDotDot={true}
					lock={props.lock}
					loading={false}
				/>
			</>
		);
	} else {
		return null;
	}
};
